// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1613":"css/admin-app.6713","9875":"css/app.6713"}[chunkId] + ".css";
};